import { gql } from '@apollo/client';

export default gql`
  fragment ProjectFields on Project {
    id
    propertyType
    title
    date
    modified
    link
    featuredImage {
      url
      width
      height
      title
    }
    heroImage {
      url
      width
      height
      title
    }
    totalComments
    tags {
      id
      name
      link
      slug
    }
    developer {
      name
      website
      website_label
      phone
    }
    completionDate
    location {
      zone {
        label
        value
        link
        parent {
          value
          label
          link
        }
      }
      district {
        label
        value
        link
        parent {
          value
          label
          link
        }
      }
      road {
        label
        value
        link
        parent {
          value
          label
          link
        }
      }
    }
    transportations {
      value
      label
      link
    }
    priceTypes {
      starting_price
      display_price
      per_square_meter
      maintenance_fee
      fund
      level {
        value
        label
      }
    }
    roomTypes {
      name
      status
      min_size
      max_size
    }
    logo {
      image {
        url
      }
      background_color
    }
  }
`;

export interface ProjectItem {
  id: number;
  propertyType: string[];
  title: string;
  date: string;
  modified: string;
  link: string;
  featuredImage: ImageData;
  heroImage: ImageData;
  totalComments: number;
  tags: Tag;
  developer: {
    name: string;
    website: string;
    website_label: string;
    phone: string;
  };
  completionDate: string;
  location: {
    zone: LocationItem[];
    district: LocationItem[];
    road: LocationItem[];
  };
  transportations: Parent[];
  priceTypes: ProjectPriceType;
  roomTypes: RoomType;
  logo: {
    image: {
      url: string;
    };
    background_color: string;
  };
}

export interface ImageData {
  url: string;
  width?: number;
  height?: number;
  title: string;
}

export interface LocationItem {
  value: string;
  label: string;
  link: string;
  parent: Parent;
}

export interface Parent {
  value: string;
  label: string;
  link: string;
}

export interface Tag {
  id: number;
  name: string;
  link: string;
  slug?: string;
}

export interface ProjectPriceType {
  starting_price: string;
  display_price: string;
  per_square_meter: string;
  maintenance_fee: string;
  fund: string;
  level: {
    value: string;
    label: string;
  };
}

export interface RoomType {
  name: string;
  status: string;
  min_size: string;
  max_size: string;
}
